<template>
  <div>
    <widgets-dialogs
      ref="widgetDialogs"
      :widgets.sync="widgets"
      :errors="errors"
      :hiddenWidgets="hiddenWidgets"
    />
    <div>
      <div class="widgets">
        <div v-if="nonFieldErrors" class="non-field-error">
          {{ nonFieldErrors }}
        </div>
        <p class="no-widgets" v-show="widgets.length === 0">
          Brak widgetów do wyświetlenia - dodaj nowy.
        </p>
        <widgets-grid
          :widgets="widgets"
          :errors="errors"
          @editWidget="editWidget"
          @removeWidget="removeWidget"
        />
        <el-button @click="addNewWidget" type="warning">
          <i class="fa fa-plus-circle" /> Dodaj nowy widget
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import WidgetsDialogs from '@/components/widgets/WidgetsDialogs'
import { orderBy } from 'lodash'
import WidgetsGrid from '@/components/widgets/input/WidgetsGrid'

export default {
  props: {
    widgets: Array,
    errors: [Array, String],
    hiddenWidgets: Array
  },
  beforeMount() {
    this.fetchData()
  },
  components: {
    WidgetsDialogs,
    WidgetsGrid
  },
  computed: {
    nonFieldErrors() {
      const isString = typeof this.errors === 'string'
      return isString && this.errors
    },
    getWidgetType() {
      return this.$store.getters.getWidgetByResourcetype
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchWidgetTypes')
    },
    editWidget(widgetIndex) {
      this.$refs.widgetDialogs.editWidget(widgetIndex)
    },
    addNewWidget() {
      const lastWidget = orderBy(
        this.widgets,
        ['y', 'x'],
        ['desc', 'desc']
      )[0] || { y: -1 }
      const widgetRow = lastWidget.y + 1
      this.$refs.widgetDialogs.openNewWidgetDialog(widgetRow)
    },
    removeWidget(widgetIndex) {
      // if row become empty after widget remove, move bottoms widget up
      const widget = this.widgets[widgetIndex]
      const emptyRowAfterRemove =
        this.widgets.filter(w => w.y === widget.y).length === 1
      this.removeItemFromFormset(this.widgets, widget)
      this.removeItemFromFormset(this.errors, this.errors[widgetIndex])
      if (emptyRowAfterRemove) {
        const widgetsToMove = this.widgets.filter(w => w.y > widget.y)
        widgetsToMove.forEach(widget => {
          widget.y = widget.y - 1
        })
      }
    },
    getWidgetTypeLabel(resourcetype) {
      const widgetType = this.getWidgetType(resourcetype)
      const label = widgetType && widgetType.label
      return label || resourcetype
    }
  }
}
</script>
<style lang="scss" scoped>
.no-widgets {
  font-size: 13px;
}
</style>
